import { BarChart3 } from 'lucide-react'

import type { DayRange } from './DayStrip'
import type { TrendPoint } from './receiptsDigest'
import { centerScrollTarget } from './scrollCenter'
import { TrendSum } from './TrendSum'
import './browse.css'

/**
 * Динамика периода: столбец на день (период до двух месяцев) или на месяц (длиннее). Высота — приход; под столбцом число
 * чеков и подпись. Столбец — кнопка: нажатие открывает его день или месяц. Значения словами — в `title` и подписи кнопки, цвет
 * ничего не несёт одним собой.
 */
export function PeriodTrend({ points, onPick }: { points: readonly TrendPoint[]; onPick: (range: DayRange) => void }) {
  const top = Math.max(...points.map((point) => point.saleSum), 0)
  // Последний столбец — самый свежий месяц или день периода: при показе он в центре видимой части.
  const last = points[points.length - 1]?.key ?? ''
  return (
    <section className="krp-trend" aria-label="Динамика по периоду">
      <h3 className="krp-trend__title">
        <BarChart3 size={16} aria-hidden="true" /> Динамика: приход по {points[0]?.key.length === 7 ? 'месяцам' : 'дням'}
      </h3>
      <ol className="krp-trend__bars" ref={centerScrollTarget(`${points[0]?.key ?? ''}:${last}`)}>
        {points.map((point) => (
          <li key={point.key} className="krp-trend__item" {...(point.key === last ? { 'data-scroll-target': true } : {})}>
            <button type="button" className="krp-trend__bar" title={point.text} aria-label={point.text} onClick={() => onPick(point.range)}>
              <span className="krp-trend__thousands" aria-hidden="true"><TrendSum text={point.thousands} /></span>
              <span className="krp-trend__value">{point.count}</span>
              <span
                className="krp-trend__fill"
                data-empty={point.count === 0}
                style={{ height: `${top === 0 ? 2 : Math.max(2, Math.round((point.saleSum / top) * 64))}px` }}
                aria-hidden="true"
              />
              <span className="krp-trend__label">{point.label}</span>
            </button>
          </li>
        ))}
      </ol>
    </section>
  )
}
